import React, { createContext, useContext, useState } from "react";
import "./Toast.scss"; // Import SCSS styles
import { IconButton } from "@mui/material";
import { Close, Done } from "@mui/icons-material";

const ToastContext = createContext();

const Toast = ({ message, type = "info", duration = 5000, onClose }) => {
    const [isVisible, setIsVisible] = useState(false); // Initially hidden

    React.useEffect(() => {
        // Delay adding class to trigger animation
        const showTimer = setTimeout(() => setIsVisible(true), 10);

        const hideTimer = setTimeout(() => {
            setIsVisible(false);
            setTimeout(onClose, 300); // Wait for exit animation
        }, duration);

        return () => {
            clearTimeout(showTimer);
            clearTimeout(hideTimer);
        };
    }, [duration, onClose]);

    return (
        <div className={`toast ${type} ${isVisible ? "animate-in" : ""}`}>
            <div className="toast-icon">
                {type === "success" && <Done />}
                {/* {type === "success" && "✔"} */}
                {type === "error" && <Close />}
                {/* {type === "error" && "✖"} */}
                {type === "warning" && "⚠"}
                {type === "info" && "i"}
            </div>
            <div className="toast-message">{message}</div>
            <button className="toast-close" onClick={onClose}>✖</button>
        </div>
    );
};


export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    const addToast = (message, type = "info", duration = 5000) => {
        const newToast = { id: Date.now(), message, type, duration };
        setToasts((prev) => [...prev, newToast]);

        setTimeout(() => removeToast(newToast.id), duration);
    };

    const removeToast = (id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    };

    const resetToast = () => {
        setToasts([]);
    };

    return (
        <ToastContext.Provider value={{ addToast, resetToast }}>
            {children}
            <div className="toast-container">
                {toasts.map((toast) => (
                    <Toast
                        key={toast.id}
                        {...toast}
                        onClose={() => removeToast(toast.id)}
                    />
                ))}
            </div>
        </ToastContext.Provider>
    );
};

// Custom Hook to use Toast
export const useToast = () => useContext(ToastContext);
